<template>
  <div class="footer">
    <div class="container">
      <div>
        <span>地址：{{address}}</span>
        <el-divider direction="vertical"></el-divider>
        <span v-if="contactNumber">联系电话：{{contactNumber}}</span>
        <el-divider v-if="contactNumber" direction="vertical"></el-divider>
        <span>邮编：{{postcode}}</span>
        <el-divider direction="vertical"></el-divider>
        <span>邮箱：{{email}}</span>
      </div>
      <div>
        <span>{{systemName}} 版权所有</span>
        <el-divider direction="vertical"></el-divider>
        <span v-html="websiteFiling"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      address:'', // 地址
      email: '',// 邮箱
      contactNumber:'', // 联系电话
      postcode:'',// 邮编
      websiteFiling: '',// 网站备案号
      systemName:'广西扶绥同正数字科技有限公司', // 系统名称
    }
  },
  computed: {
    storeArea() {
      return this.$store.state.cityArea;
    }
  },
  watch: {
    storeArea(newVal, oldVal){
      this.websiteCopyright()
    }
  },
  async created() {
    // await this.websiteCopyright()
  },
  methods: {
    async websiteCopyright(){
      await this.$api.my.websiteCopyright({areaConfigId:this.storeArea.areaConfigId}).then(res => {
        if(res.code == 1000 && res.data){
          this.address = res.data.address || ''
          this.contactNumber = res.data.contactNumber || ''
          this.postcode = res.data.postcode || ''
          this.websiteFiling = res.data.websiteFiling || ''
          this.email = res.data.email || ''
          this.$store.commit('SET_LOGO',res.data.logoUrl||'')
          // if(res.data.systemName) this.systemName = res.data.name + res.data.systemName
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 128px;
  background: rgba(57, 66, 89, 1);
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  .container {
    width: 1200px;
    margin: 0 auto;
    div {
      color: #a8aaae;
      font-size: 10px;
      margin: 0 12px;
      .el-divider {
        background: #a8aaae;
      }
    }
  }
}
</style>
